import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { PatientModel, PatientSessionModel } from '../../core/api/models';
import { OfflineDataService } from '../../core/services/offline-data.service';
import { PatientOfflineData } from '../../core/services/offline-data.service';
import { AlertService } from '../../shared/services/alert.service';
@Component({
  selector: 'app-offline-patient',
  templateUrl: './offline-patient.component.html',
  styleUrls: ['./offline-patient.component.css'],
  providers: [DatePipe],
  standalone: false,
})
export class OfflinePatientComponent implements OnInit {
  patientId: number | null = null;
  patient: PatientModel | null = null;
  offlineData: PatientOfflineData | null = null;
  loading: boolean = true;
  errorMessage: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private offlineDataService: OfflineDataService,
    private datePipe: DatePipe,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.patientId = Number(params['id']);
      this.loadPatientData();
    });
  }

  loadPatientData(): void {
    if (!this.patientId) {
      this.errorMessage = 'Invalid patient ID';
      this.loading = false;
      return;
    }

    this.offlineData = this.offlineDataService.getOfflinePatientData(this.patientId);
    if (!this.offlineData) {
      this.errorMessage = 'Patient data not found offline';
      this.loading = false;
      return;
    }

    this.patient = this.offlineData.patient;
    this.offlineData.sessions = this.offlineData.sessions.filter(session => session.ID !== -1);
    this.loading = false;
  }

  getDataSummary(): { label: string, count: number }[] {
    if (!this.offlineData) return [];

    return [
      { label: 'Behaviors', count: this.offlineData.behaviors.length },
      { label: 'Targets', count: this.offlineData.targets.length },
      { label: 'Active Sessions', count: this.offlineData.sessions.length },
      { label: 'Behavior Locations', count: this.offlineData.behaviorLocations.length },
      { label: 'Behavior Consequences', count: this.offlineData.behaviorConsequences.length },
      { label: 'Behavior Responses', count: this.offlineData.behaviorResponses.length },
      { label: 'Behavior Severities', count: this.offlineData.behaviorSeverities.length },
      { label: 'Behavior Antecedents', count: this.offlineData.behaviorAntecedents.length }
    ];
  }

  formatDate(date: Date | string | null | undefined): string {
    if (!date) return '';
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return this.datePipe.transform(dateObj, 'MMM d, y, h:mm a') || '';
  }

  goToSession(session: PatientSessionModel): void {
    this.router.navigate(['/staff/home', this.patientId, session.ID]);
  }

  backToOfflinePatients(): void {
    this.router.navigate(['/offline/patients']);
  }

  getSessionStatus(session: PatientSessionModel): string {
    if (!session.StartedDate) return 'New';
    return 'Started';
  }

  getSessionStatusClass(session: PatientSessionModel): string {
    if (!session.StartedDate) return 'bg-warning';
    return 'bg-success';
  }

  getSessionStatusIcon(session: PatientSessionModel): string {
    if (!session.StartedDate) return 'pi pi-clock';
    return 'pi pi-check';
  }

  removeAllData(): void {
    //If has any dirty sessions, show a confirmation dialog
    if (this.offlineData?.sessions.some(session => (session.isDirty && (session.ID || 0) >= 0))
    || (this.offlineData?.progressNotes && Object.values(this.offlineData.progressNotes).some(note => (note as any).isDirty))) {
        this.alertService.confirm('You have unsaved data for this patient','Are you sure you want to delete and loose all offline data for this patient?').subscribe((result: boolean) => {
        if (result) {
          this.deleteAllData();
        }
      });
    } else {
      this.deleteAllData();
    }
  }

  deleteAllData(): void {

    if (!this.patientId) return;
    this.offlineDataService.removeOfflinePatientData(this.patientId);
    this.router.navigate(['/offline/patients']);
  }
} 